var sliders_group = ( function( $ ) {

	var $group,
		$links,
		$sliders,
		slide_speed;

	var _init = function() {
		$group      = $( '#slider-group' );
		$links      = $group.find( '.slider-group-nav ul.links li.link' );
		$sliders    = $group.find( '.slider' );
		slide_speed = 8000;

		$links.each( function() {
			_setup_slider_switch_link( $( this ) );
		} );

		$sliders.each( function() {
			_maybe_setup_slider( $( this ) );
		});
	};

	var _setup_slider_switch_link = function( $link_li ) {
		var $link = $link_li.find( 'a' );

		$link.on( 'click', function( e ) {
			var $slider = $( $( this ).attr( 'href' ) );

			e.preventDefault();

			if ( ! $link_li.hasClass( 'active' ) ) {
				$links.removeClass( 'active' );
				$link_li.addClass( 'active' );
			}

			if ( $slider.length > 0 && ! $slider.hasClass( 'active' ) ) {
				_switch_slider( $slider );
			}
		} );
	};

	var _switch_slider = function( $slider ) {
		$sliders.css( 'display', 'none' );
		$sliders.removeClass( 'active' );
		$slider.fadeIn();
		$slider.addClass( 'active' );

		_maybe_setup_slider( $slider )
	};

	var _maybe_setup_slider = function( $slider_tab ) {
		if ( $slider_tab.find( '.owl-carousel' ).hasClass( 'owl-loaded' ) ) {
			return;
		}

		if ( $slider_tab.hasClass( 'active' ) ) {
			_setup_slider( $slider_tab.find( '.owl-carousel' ) );
		}
	};

	var _setup_slider = function ( $slider ) {
		$slider.on( 'initialized.owl.carousel', function( event ) {
			_slider_initialised( event, $slider )
		} );

		$slider.owlCarousel( {
			items: 1,
			loop: true,
			nav: true,
			navText: [
				'<div class="triangle left prev"></div>',
				'<div class="triangle right next"></div><svg><circle r="23" cx="25" cy="25"></circle></svg>'
			],
			dots: false,
			autoplay: true,
			autoplayTimeout: slide_speed,
			animateOut: 'fadeOut',
			slideSpeed: 10
		} );

		$slider.on( 'translate.owl.carousel', function( event ) {
			_start_timer( event, $slider );
		} );
	};

	var _slider_initialised = function( event, $slider ) {
		$slider.find( '.owl-item .slide' ).addClass( 'initialised' );

		_start_timer( event, $slider );

		_setup_slide_text( $slider );
	};

	var _start_timer = function( event, $slider ) {
		$slider.find( '.owl-controls .owl-next' ).removeClass( 'begin-animate' );

		setTimeout( function() {
			$slider.find( '.owl-controls .owl-next' ).addClass( 'begin-animate' );
		}, 10 );
	};

	var _setup_slide_text = function( $slider ) {
		$slider.find( 'a.open-text' ).on( 'click', function( e ) {
			e.preventDefault();
			$( this ).siblings( '.slide-text' ).fadeToggle().toggleClass( 'shown' );
			$( this ).toggleClass( 'active' );
		} )
	};

	if ( $( '#slider-group' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = sliders_group;